import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DeleguesService } from 'src/app/services/delegues.service';
import { take } from 'rxjs';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { environment } from 'src/environments/environment';
import { AgentDelegationModalComponent } from './agent-delegation-modal/agent-delegation-modal.component';
import { Broadcast } from 'src/app/core/services/broadcast.service';
import { DataTableComponent } from 'src/app/shared/data-table/data-table.component';
import { CommunicationService } from 'src/app/shared/communication.service';
import { DeleteModalComponent } from 'src/app/shared/delete-modal/delete-modal.component';
import { ValidationModalComponent } from 'src/app/shared/validation-modal/validation-modal.component';
import { AlerteModalComponent } from 'src/app/shared/alerte-modal/alerte-modal.component';
import { RoleService } from 'src/app/core/services/role.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
@Component({
  selector: 'app-delegation-modal',
  imports: [
    MatCardModule,
    DatePipe,
    MatIconModule,
    MatButtonModule,
    MatNativeDateModule,
    MatInputModule,
    MatDatepickerModule,
    MatDividerModule,
    DataTableComponent,
    MatDialogModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatTabsModule
  ],
  templateUrl: './delegation-modal.component.html',
  styleUrls: ['./delegation-modal.component.scss']
})
export class DelegationModalComponent implements OnInit {
  @ViewChild('appDataTable') appDataTable: DataTableComponent;

  viewMode: 'read' | 'edit' | 'user';
  firstName: string;
  lastname: string;
  lenght: number;
  userName: string;
  userRoles: string[] = [];
  agentId: number;
  userId: any;
  fullName: string;
  matricule: string;
  dataJSON: any[] = [];
  delegationList: any[] = [];
  pipe = new DatePipe('fr-FR');
  delegueRow: any = {};
  DebutDates: any;
  FinDates: any;
  filterValue: string = '';
  activeTabIndex = 0;
  agentData: any = null;

  displayedColumns: string[] = ['Date de début', 'Date de fin', "Nom de l'Agent", 'Actions'];
  displayedViewColumns: string[] = ['Date de début', 'Date de fin', "Nom de l'Agent"];
  displayedUserColumns: string[] = ['Date de début', 'Date de fin', "Nom de l'Agent", 'Actions'];
  cellStyleCss: any = {};
  constructor(
    public dialogRef: MatDialogRef<DelegationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private readonly broadcast: Broadcast,
    public agentDialog: MatDialog,

    private readonly notifyService: CommunicationService,
    private readonly roleService: RoleService,
    private readonly detectorRef: ChangeDetectorRef,
    private readonly delegationService: DeleguesService
  ) {}

  ngOnInit() {
    this.roleService.getRole().subscribe((roles) => {
      this.userRoles = roles;
    });
    this.agentId = this.data.agentId;
    this.userId = this.data.idUser;
    this.userName = this.data.name;
    this.firstName = this.data.agentName;
    this.lastname = this.data.agentPrenom;
    this.fullName = this.firstName + ' ' + this.lastname;
    this.matricule = this.data.agentMatricule;
    this.agentData = this.data.agentData || null;
    this.loadDelegationList();

    if (this.data.viewMode) {
      this.viewMode = this.data.viewMode;
    }
  }

  onTabChanged(event: MatTabChangeEvent) {
    this.activeTabIndex = event.index;
  }
  onBackToAgentList() {
    this.dialogRef.close();
    this.notifyService.setNbAgent(this.lenght);
    this.notifyService.triggerRefresh();
  }
  openCreateAgentDelegation() {
    this.dialog
      .open(AgentDelegationModalComponent, {
        width: '900px',
        hasBackdrop: true,
        disableClose: true,
        autoFocus: false,
        data: {
          remplaceId: this.data.agentId,
          Dates: this.DebutDates,
          FinDates: this.FinDates,
          DelegationAgent: this.delegationList,
          agentMatricule: this.matricule,
          idUser: this.userId,
          agentId: this.agentId,
          nameUser: this.userName,
          // nameUser: this.firstName,
          view: this.data.viewMode
        }
      })
      .afterClosed()
      .subscribe((result) => {
        this.loadDelegationList();

        this.broadcast.broadcastEvent({
          broadcastedevent: 'resetPagination'
        });
      });
  }
  transformDelegationData() {
    let dataDelegue: any[] = [];

    for (let key in this.dataJSON) {
      let dataJ = this.dataJSON[key];
      let _data: any = {};

      _data['id'] = dataJ?.id;

      _data['Nom'] = dataJ['nom'];
      _data['Date de début'] = this.pipe.transform(dataJ?.dateDebut, 'shortDate');
      _data['Date de fin'] = this.pipe.transform(dataJ?.dateFin, 'shortDate');
      _data["Nom de l'Agent"] = dataJ?.remplacant?.nom + ' ' + dataJ?.remplacant?.prenom;

      dataDelegue.push(_data);
    }

    return dataDelegue;
  }
  delegueDataId(data: any, id: number) {
    let index = Object.keys(data).find((k) => data[k].id === id);

    if (index != null) {
      this.delegueRow = data[Number(index)];
    }
  }

  deleteDelegue(id: number, mesDelegues = true) {
    const dialogRef = this.dialog.open(DeleteModalComponent, {
      width: '780px',
      data: {
        id: id,
        description: 'Voulez-vous supprimer le délégué ?',
        url: 'test'
      }
    });

    dialogRef.afterClosed().subscribe((action) => {
      if (action === true && this.data.view !== 'user') {
        let data_id: number = id;

        if (this.userRoles.includes('pama-admin') && !mesDelegues) {
          this.delegationService
            .supprimerDelegue(data_id)
            .pipe(take(1))
            .subscribe({
              next: (result) => {
                this.dialog
                  .open(ValidationModalComponent, {
                    width: '600px',
                    data: {
                      title: 'Confirmation',
                      content: 'La délégation a été supprimée avec succès.'
                    }
                  })
                  .afterClosed()
                  .subscribe(() => {
                    dialogRef.close();
                    this.loadDelegationList();
                    this.detectorRef.detectChanges();
                  });
              },
              error: (error) => {
                let erreur_texte = error.error.detail || error.error || error;
                this.dialog.open(AlerteModalComponent, {
                  width: '640px',
                  data: {
                    title: 'Alerte',
                    content: "Erreur lors de la suppression de l'enregistrement !",
                    status: 'STATUS: ' + error.status,
                    detail: 'DETAIL: ' + erreur_texte
                  }
                });
              }
            });
        } else if (
          this.userRoles.includes('pama-admin') ||
          this.userRoles.includes('pama-demandeur') ||
          this.userRoles.includes('pama-valideur')
        ) {
          this.delegationService
            .supprimerMonDelegue(data_id)
            .pipe(take(1))
            .subscribe({
              next: (result) => {
                this.dialog
                  .open(ValidationModalComponent, {
                    width: '600px',
                    data: {
                      title: 'Confirmation',
                      content: 'Le délégué a été supprimé avec succès.'
                    }
                  })
                  .afterClosed()
                  .subscribe(() => {
                    this.loadDelegationList();
                    this.detectorRef.markForCheck();
                  });
              },
              error: (error) => {
                let erreur_texte = error.error.detail || error.error || error;
                this.dialog.open(AlerteModalComponent, {
                  width: '640px',
                  data: {
                    title: 'Alerte',
                    content: "Erreur lors de la suppression de l'enregistrement !",
                    status: 'STATUS: ' + error.status,
                    detail: 'DETAIL: ' + erreur_texte
                  }
                });
              }
            });
        }
      } else {
      }
    });
  }

  modifyDelegate(id: any) {
    this.delegueDataId(this.dataJSON, id);
    this.agentDialog
      .open(AgentDelegationModalComponent, {
        width: '900px',
        hasBackdrop: true,
        disableClose: true,
        autoFocus: false,
        data: {
          remplaceId: this.data.agentId,
          Dates: this.DebutDates,
          FinDates: this.FinDates,
          DelegationAgent: this.delegationList,
          agentMatricule: this.matricule,
          idUser: this.userId,
          nameUser: this.userName,
          view: this.data.viewMode,
          delegue: this.delegueRow,
          modif: true
        }
      })
      .afterClosed()
      .subscribe((result) => {
        this.loadDelegationList();
      });
  }

  loadDelegationList() {
    if (this.data.viewMode === 'user') {
      this.delegationService
        .getMesDelegues()
        .pipe(take(1))
        .subscribe((data: any) => {
          if (data) {
            this.dataJSON = data.results;
            this.delegationList = this.transformDelegationData();

            this.DebutDates = this.delegationList.map((date) => date['Date de début']);
            this.FinDates = this.delegationList.map((date) => date['Date de fin']);
            this.detectorRef.markForCheck();
            this.lenght = data.totalRecords;

            /**
             * Communication du nouveau nombre de délégués
             */
            this.notifyService.setNbAgent(this.lenght);
            this.notifyService.triggerRefresh();
          } else {
          }
        });
    } else {
      this.delegationService
        .getDeleguesAgent(this.data.agentId)
        .pipe(take(1))
        .subscribe((data: any) => {
          if (data) {
            this.dataJSON = data.results;
            this.delegationList = this.transformDelegationData();

            this.DebutDates = this.delegationList.map((date) => date['Date de début']);
            this.FinDates = this.delegationList.map((date) => date['Date de fin']);
            this.detectorRef.markForCheck();
            this.lenght = data.totalRecords;

            /**
             * Communication du nouveau nombre de délégués
             */
            this.notifyService.setNbAgent(this.lenght);
            this.notifyService.triggerRefresh();
          } else {
          }
        });
    }
  }

  updatePagination(event: any) {
    if (event) {
      this.delegationService
        .getDeleguesWithParams(event.offset, event.limit, this.agentId, event.filterValue)
        .pipe(take(1))
        .subscribe({
          next: (result) => {
            this.dataJSON = result.results;
            this.delegationList = this.transformDelegationData();
            this.detectorRef.markForCheck();
            this.lenght = result.totalRecords;
          },
          error: (error) => {}
        });
    } else {
      this.delegationService
        .getDeleguesWithParams(environment.pagination.offset, environment.pagination.limit, this.agentId)
        .pipe(take(1))
        .subscribe({
          next: (result) => {
            this.dataJSON = result.results;
            this.delegationList = this.transformDelegationData();
            this.detectorRef.markForCheck();
            this.lenght = result.totalRecords;
          },
          error: (error) => {}
        });
    }
  }
  updateFiltre(value: any) {
    this.filterValue = value.filterValue;
    this.updatePagination(value);
  }
}
